<template>
	<v-toolbar-items>
		<v-btn
			small
			text
			v-for="locale in availableLocales"
			:key="locale"
			@click="setLocale(locale)"
			>{{ locale }}</v-btn
		>
	</v-toolbar-items>
</template>

<script>
export default {
	computed: {
		availableLocales() {
			// return this.$locales().filter((i) => i != this.$locale());
			return this.$locales();
		},
	},

	methods: {
		setLocale(locale) {
			this.$setLocale(locale);
			// window.location.reload();
		},
	},
};
</script>